import { CivilUnionDetailAnscNotificationsNonResidentMutationCrumbs } from 'mutation/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import PersonCivilUnionNonResidentAnscNotificationCivilStatusShared from 'shell/components/shared/ansc-notifications/research-civil-union-non-resident/edit-person';
import { IdAmbito } from 'shell/constants/id-ambito';

const PersonCivilUnionNonResidentAnscNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <PersonCivilUnionNonResidentAnscNotificationCivilStatusShared
        items={CivilUnionDetailAnscNotificationsNonResidentMutationCrumbs()}
        scope={IdAmbito.Mutazioni}
      />
    </Fragment>
  );
};

PersonCivilUnionNonResidentAnscNotificationCivilStatusPage.displayName =
  'Research CivilUnion Non Resident Notifications Page component';

export default PersonCivilUnionNonResidentAnscNotificationCivilStatusPage;
